import { render, staticRenderFns } from "./ChooseSeatsComponent.vue?vue&type=template&id=886f7604"
import script from "./ChooseSeatsComponent.vue?vue&type=script&lang=js"
export * from "./ChooseSeatsComponent.vue?vue&type=script&lang=js"
import style0 from "./ChooseSeatsComponent.vue?vue&type=style&index=0&id=886f7604&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports